/**
 * Parse LINESTRING WKT (lng lat pairs) to Leaflet [lat, lng] coordinates.
 * Supports comma-separated pairs (OSM/transmission) and space-separated
 * sequences (GEM gas export: "lng lat lng lat ...").
 */
export function parseLinestringGeometry(geometry) {
  const raw = typeof geometry === 'string' ? geometry.trim() : '';
  if (!raw || !/^LINESTRING/i.test(raw)) {
    return null;
  }

  try {
    const coordsMatch = raw.match(/^LINESTRING\s*\((.*)\)\s*$/is);
    if (!coordsMatch) return null;

    const inner = coordsMatch[1].trim();
    const nums = inner
      .replace(/,/g, ' ')
      .split(/\s+/)
      .map(Number)
      .filter((n) => Number.isFinite(n));

    if (nums.length < 4 || nums.length % 2 !== 0) {
      return null;
    }

    const latLngs = [];
    for (let i = 0; i < nums.length; i += 2) {
      const lng = nums[i];
      const lat = nums[i + 1];
      latLngs.push([lat, lng]);
    }

    return latLngs.length >= 2 ? latLngs : null;
  } catch (error) {
    console.warn('Error parsing geometry:', error);
    return null;
  }
}
